import { Drawer, List, useMediaQuery, useTheme } from '@mui/material';
import * as urls from 'routes/config';
import SidebarItem from './SidebarItem';
import TeamIcon from 'assets/icons/TeamIcon';
import ConfigureIcon from 'assets/icons/ConfigureIcon';
import IntegrationIcon from 'assets/icons/IntegrationIcon';
// import DashboardIcon from 'assets/icons/DashboardIcon';
import AgentTemplate from 'assets/icons/AgentTemplate';
// import PromptIcon from 'assets/icons/PromptIcon';
import { IoIosBusiness } from 'react-icons/io';
import { MdOutlineSignalCellularAlt } from 'react-icons/md';
// import { CiCreditCard2 } from 'react-icons/ci';

interface Props {
  isMenuOpen?: boolean;
  handleClose?: () => void;
}

export default function AgencySidebar({ isMenuOpen, handleClose }: Props) {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Drawer
      variant={isMediumScreen ? 'temporary' : 'permanent'}
      open={isMediumScreen ? isMenuOpen : true}
      onClose={handleClose}
      anchor='left'
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          top: isMediumScreen ? 0 : '97px',
          backgroundColor: theme.palette.background.paper
        }
      }}
      ModalProps={{
        keepMounted: true
      }}
    >
      {drawerContent}
    </Drawer>
  );
}

const drawerContent = (
  <List>
    {/* <SidebarItem to={urls.agency.dashboard} icon={<DashboardIcon />} label='Dashboard' end={true} /> */}
    <SidebarItem
      to={urls.agency.usage}
      icon={<MdOutlineSignalCellularAlt style={{ width: 24, height: 24 }} />}
      label='Usage'
      end={true}
    />
    <SidebarItem
      to={urls.agency.businesses}
      icon={<IoIosBusiness style={{ width: 24, height: 24 }} />}
      label='Businesses'
    />
    {/* <SidebarItem to={urls.agency.billing} icon={<BillingIcon />} label='Billing' /> */}
    <SidebarItem to={urls.agency.team} icon={<TeamIcon />} label='Team' />
    <SidebarItem to={urls.agency.configuration} icon={<ConfigureIcon />} label='Configuration' />
    <SidebarItem to={urls.agency.integrations} icon={<IntegrationIcon />} label='Integrations' />
    <SidebarItem to={urls.agency.agentTemplate} icon={<AgentTemplate />} label='Agent Templates' />
    {/* <SidebarItem to={urls.agency.prompts} icon={<PromptIcon />} label='Prompts' /> */}
    {/* <SidebarItem to={urls.agency.plans} icon={<CiCreditCard2 style={{ width: 24, height: 24 }} />} label='Plans' /> */}
  </List>
);
